<mat-form-field class="w-full" appearance="outline" [floatLabel]="floatLabel">
  <mat-label i18n="@@loan_state">Loan State</mat-label>
  <mat-select
    (selectionChange)="statusChange($event.value)"
    [formControl]="ctrl"
  >
    <mat-option value="">All</mat-option>
    <mat-option value="RUNNING">Running</mat-option>
    <mat-option value="CLOSED">Closed</mat-option>
    <!-- <mat-option value="REJECTED">Rejected</mat-option> -->
    <!-- <mat-option value="DISBURSED">Disbursed</mat-option>
    <mat-option value="WITHDRAWN">Withdrawn</mat-option>
    <mat-option value="PENDING">Pending</mat-option>
    <mat-option value="APPROVED">Approved</mat-option>
    <mat-option value="OVERPAID">Overpaid</mat-option>
    <mat-option value="WRITTEN_OFF">Written Off</mat-option>
    <mat-option value="CANCELLED">Cancelled</mat-option> -->
  </mat-select>
</mat-form-field>
